module.exports = __webpack_public_path__ + "static/img/xj1-1.6224233.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/xj1-1.png
// module id = 724
// module chunks = 0